import React from "react";
import styled, {css} from "styled-components";
import Loader from "../../../components/UI/Loader";
import { useHistory } from "react-router-dom";
import { FormatDateTimeToString } from "global/datahelper";
import { UseOrganizationContext } from "contexts";
import Status from "components/UI/Status";

const Container = styled.div`
`;


const ContactGrid = ({ items }) => {
  const history = useHistory();
  const { isCompany, isTown } = UseOrganizationContext();

  const open = (id) => {   
    history.push("/contacts/view/" + id);
  };

  return (
    <Container> 
      <table cellSpacing="500">
        <thead>
          <tr>    
            <th>Voornaam</th>
            <th>Achternaam</th>
            <th>Email</th>
          </tr>
        </thead>
        <tbody>
        {!items 
          ? <Loader center />
            : <> 
              {items.map((item, idx) => (          
                  <tr key={item.id + '_' + idx} onClick={() => open(item.id)} className="clickable">          
                    <td>{item.firstName}</td>   
                    <td>{item.lastName}</td>   
                    <td>{item.email}</td>      
                  </tr>      
              ))}
              </>
        }
        </tbody>
      </table>
   </Container>
  );
};

ContactGrid.defaultProps = {
  items: Array.from(Array(3)),
  direction: 'row'
};

export default ContactGrid;
